import { z } from 'zod';
export { TemplateType, templateTypeGuard } from '@logto/connector-kit';
export const emailTemplateDetailsGuard = z.object({
    subject: z.string(),
    content: z.string(),
    contentType: z.union([z.literal('text/html'), z.literal('text/plain')]).optional(),
    replyTo: z.string().optional(),
    sendFrom: z.string().optional(),
});
